import { useEffect, useState } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";
import MDButton from "components/MDButton";
import { Checkbox, CircularProgress, FormControlLabel, Icon, Stack } from "@mui/material";
import { Link } from "react-router-dom";
import LHHCApiService from "app/services/LHHCApiService";
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from '@mui/material';
import TopNavBar from "app/layout/TopNavBar";
import moment from 'moment';
import SubscriptionService from "app/services/SubscriptionServices";
import MDInput from "components/MDInput";
import { useMaterialUIController } from "context";

function Horoscope({ }) {
    const subscriptionService = SubscriptionService();
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;

    const isMobile = useMediaQuery('(max-width:600px)');
    const { t } = useTranslation();
    const apiService = LHHCApiService();
    const [horoscopeData, setHoroscopeData] = useState([]);
    const [filteredHoroscopeData, setFilteredHoroscopeData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [loading, setLoading] = useState(true);

    const searchedHoroscopeData = filteredHoroscopeData.filter((record) =>
        JSON.stringify(record).toLowerCase().includes(searchQuery.toLowerCase())
    );

    const mobileColumns = [
        {
            Header: "", accessor: "fileType", width: "25%", sortable: false,
            Cell: ({ cell }) => (
                <MDButton
                    component={Link}
                    to={`/my-files/${cell.row.original.fileType == 2 ? "match/" : ""}view/${cell.row.original.id}`}
                    variant="outlined"
                    color="success"
                    iconOnly
                    sx={{
                        width: 32,
                        height: 32,
                        minWidth: 32,
                        minHeight: 32,
                        p: 0,
                        borderColor: 'success.main',
                        color: 'success.main',
                        '&:hover': {
                            borderColor: 'success.dark',
                            backgroundColor: 'rgba(76, 175, 80, 0.04)'
                        }
                    }}
                >
                    <Icon sx={{ fontSize: '0.9rem !important' }}>open_in_new</Icon>
                </MDButton>
            )
        },
        {
            Header: t("Description"), accessor: "description",
            Cell: ({ cell }) => <>{cell.row.original.name} <br /> {cell.row.original.description}</>
        },
    ];
    const desktopColumns = [
        {
            Header: "", accessor: "fileType", width: "11%", sortable: false,
            Cell: ({ cell }) => (
                <MDButton
                    component={Link}
                    to={`/my-files/${cell.row.original.fileType == 2 ? "match/" : ""}view/${cell.row.original.id}`}
                    variant="outlined"
                    color="success"
                    size="small"
                    sx={{
                        textTransform: 'none',
                        borderColor: 'success.main',
                        color: 'success.main',
                        minHeight: 40,
                        height: 40,
                        px: 1.5,
                        fontSize: '0.875rem',
                        '&:hover': {
                            borderColor: 'success.dark',
                            backgroundColor: 'rgba(76, 175, 80, 0.04)'
                        }
                    }}
                >
                    <Icon sx={{
                        mr: 0.5,
                        fontSize: '1.4rem',
                        lineHeight: 0,
                        width: '1.4rem',
                        height: '1.4rem',
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                        verticalAlign: 'middle',
                    }}>open_in_new</Icon> {t("Open")}
                </MDButton>
            )
        },
        {
            Header: t("Created"), accessor: "createdOn", width: "12%",
            Cell: ({ cell }) => {
                const createdOn = moment(new Date(cell.row.original.createdOn));

                return (
                    <MDBox display="flex" flexDirection="column">
                        <MDTypography variant="body2" fontWeight="medium">
                            {createdOn.format('DD/MM/YY')}
                        </MDTypography>
                        <MDTypography variant="caption" color="text.secondary" fontWeight="regular">
                            {createdOn.format('HH:mm')}
                        </MDTypography>
                    </MDBox>
                );
            }
        },
        { Header: t("Name"), accessor: "name", width: "12%" },
        { Header: t("Description"), accessor: "description" },
    ];
    const columns = isMobile ? mobileColumns : desktopColumns;

    const fetchData = async () => {
            try {
                await subscriptionService.getSubscriptions();
            } catch (err) {
                console.log(err);
            }
        };
        useEffect(() => {

            fetchData();
        }, []);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const data = await apiService.list();
                setHoroscopeData(data);
                console.log(data);
            } catch (err) {
                console.log(err);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    const [showHC, setShowHC] = useState(true);
    const [showMatches, setShowMatches] = useState(true);

    useEffect(() => {
        console.log("Filtering data with showHC:", showHC, "showMatches:", showMatches);
        let filteredData;
        if ((showHC && showMatches) || (!showHC && !showMatches)) {
            // Show all records if both are true or both are false
            filteredData = horoscopeData;
        } else if (showHC) {
            // Show only fileType = 1
            console.log("Filtering for fileType = 1", horoscopeData[0].fileType);
            filteredData = horoscopeData.filter(item => item.fileType == 1);
        } else if (showMatches) {
            // Show only fileType = 2
            console.log("Filtering for fileType = 2", horoscopeData[0].fileType);
            filteredData = horoscopeData.filter(item => item.fileType == 2);
        } else {
            filteredData = [];
        }
        setFilteredHoroscopeData(filteredData);
        console.log("Filtered Data: ", filteredData.length);
    }, [showHC, showMatches, horoscopeData]);

    return (
        <DashboardLayout>
            <TopNavBar />
            <MDBox pt={1} pb={1}>
                <MDBox mb={1}>
                    <Card>
                        {/* Page title */}
                        <MDBox
                            pt={2}
                            px={2}
                            pb={1.5}
                            sx={{
                                backgroundColor: darkMode ? '#202a3a' : '#c7d9e9',
                                borderBottom: darkMode ? '1px solid #34445a' : '1px solid #b5cadc',
                                borderTopLeftRadius: '0.75rem',
                                borderTopRightRadius: '0.75rem',
                            }}
                        >
                            <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
                                <MDTypography variant="h6" fontWeight="bold" color={darkMode ? "white" : "dark"} noWrap>
                                    {t("HC.MY_PREVOUS_WORK")}
                                </MDTypography>
                                {!isMobile && (
                                    <MDBox
                                        width={{ sm: "12rem", md: "16rem" }}
                                        flexShrink={0}
                                    >
                                        <MDInput
                                            placeholder="Search..."
                                            value={searchQuery}
                                            size="small"
                                            fullWidth
                                            onChange={(event) => setSearchQuery(event.target.value)}
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    backgroundColor: darkMode ? '#303846' : '#ffffff',
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        borderColor: darkMode ? '#62758b' : '#9bb3c9',
                                                    },
                                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                                        borderColor: darkMode ? '#8da6bf' : '#6f8da8',
                                                    },
                                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                        borderColor: darkMode ? '#b8d2ea' : '#426a8d',
                                                        borderWidth: 2,
                                                    },
                                                    '& input': {
                                                        color: darkMode ? '#ffffff' : 'inherit',
                                                    },
                                                    '& input::placeholder': {
                                                        color: darkMode ? 'rgba(255, 255, 255, 0.7)' : 'inherit',
                                                        opacity: 1,
                                                    },
                                                },
                                            }}
                                        />
                                    </MDBox>
                                )}
                            </Stack>
                        </MDBox>

                        {/* Create buttons */}
                        <MDBox px={2} pt={1.5} pb={0}>
                            <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5}>
                                <MDButton
                                    component={Link}
                                    to="/my-files/horoscope/new"
                                    variant="contained"
                                    color="info"
                                    startIcon={<Icon>add_circle</Icon>}
                                    sx={{
                                        flex: 1, minHeight: 44,
                                        textTransform: 'none',
                                        fontSize: '0.875rem',
                                        backgroundColor: darkMode ? 'rgba(33, 150, 243, 0.28)' : 'rgba(33, 150, 243, 0.12)',
                                        color: darkMode ? '#ffffff' : 'info.dark',
                                        transition: 'all 0.2s',
                                        '&:hover': {
                                            backgroundColor: darkMode ? 'rgba(33, 150, 243, 0.4)' : 'rgba(33, 150, 243, 0.2)',
                                            boxShadow: 2,
                                            transform: 'translateY(-2px)',
                                        },
                                    }}
                                >
                                    {t("HC.HC_NEW")}
                                </MDButton>
                                <MDButton
                                    component={Link}
                                    to="/my-files/match/new"
                                    variant="contained"
                                    color="warning"
                                    startIcon={<Icon>add_circle</Icon>}
                                    sx={{
                                        flex: 1, minHeight: 44,
                                        textTransform: 'none',
                                        fontSize: '0.875rem',
                                        backgroundColor: darkMode ? 'rgba(255, 152, 0, 0.28)' : 'rgba(255, 152, 0, 0.12)',
                                        color: darkMode ? '#ffffff' : 'warning.dark',
                                        transition: 'all 0.2s',
                                        '&:hover': {
                                            backgroundColor: darkMode ? 'rgba(255, 152, 0, 0.4)' : 'rgba(255, 152, 0, 0.2)',
                                            boxShadow: 2,
                                            transform: 'translateY(-2px)',
                                        },
                                    }}
                                >
                                    {t("HC.HC_NEW_MATCH")}
                                </MDButton>
                                <MDButton
                                    component={Link}
                                    to="/applications/rahu-kalaya"
                                    variant="contained"
                                    color="success"
                                    startIcon={<Icon>calendar_month</Icon>}
                                    sx={{
                                        flex: 1, minHeight: 44,
                                        textTransform: 'none',
                                        fontSize: '0.875rem',
                                        backgroundColor: darkMode ? 'rgba(0, 150, 136, 0.3)' : 'rgba(0, 150, 136, 0.12)',
                                        color: darkMode ? '#ffffff' : '#00695c',
                                        transition: 'all 0.2s',
                                        '&:hover': {
                                            backgroundColor: darkMode ? 'rgba(0, 150, 136, 0.42)' : 'rgba(0, 150, 136, 0.2)',
                                            boxShadow: 2,
                                            transform: 'translateY(-2px)',
                                        },
                                    }}
                                >
                                    රාහු කාල දින දර්ශනය
                                </MDButton>
                            </Stack>
                        </MDBox>

                        {/* Filter checkboxes + record count */}
                        <MDBox px={2} pt={0.5} pb={0}>
                            <Stack direction="row" alignItems="center" justifyContent="space-between">
                                <Stack direction="row" alignItems="center">
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={showHC}
                                                onChange={(e) => setShowHC(e.target.checked)}
                                                size="small"
                                                sx={{
                                                    color: 'info.main',
                                                    '&.Mui-checked': { color: 'info.main' },
                                                }}
                                            />
                                        }
                                        label={
                                            <MDTypography variant="caption" fontWeight="medium">
                                                {t("HC.SHOW_HC")}
                                            </MDTypography>
                                        }
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={showMatches}
                                                onChange={(e) => setShowMatches(e.target.checked)}
                                                size="small"
                                                sx={{
                                                    color: 'warning.main',
                                                    '&.Mui-checked': { color: 'warning.main' },
                                                }}
                                            />
                                        }
                                        label={
                                            <MDTypography variant="caption" fontWeight="medium">
                                                {t("HC.SHOW_MATCH")}
                                            </MDTypography>
                                        }
                                    />
                                </Stack>
                                {!loading && (
                                    <MDTypography variant="subtitle2" color="text">
                                        {t("Records")}: {filteredHoroscopeData.length}
                                    </MDTypography>
                                )}
                            </Stack>
                        </MDBox>

                        {/* Loading spinner */}
                        {loading && (
                            <MDBox display="flex" justifyContent="center" py={4}>
                                <CircularProgress color="info" />
                            </MDBox>
                        )}

                        {/* Empty state */}
                        {!loading && searchedHoroscopeData.length === 0 && (
                            <MDBox display="flex" justifyContent="center" alignItems="center" py={4}>
                                <Icon sx={{ color: "text.secondary", mr: 1 }}>inbox</Icon>
                                <MDTypography variant="body2" color="text">
                                    No records found.
                                </MDTypography>
                            </MDBox>
                        )}

                        {/* Data table */}
                        {!loading && searchedHoroscopeData.length > 0 && (
                            <DataTable table={{
                                columns: columns,
                                rows: searchedHoroscopeData
                            }} canSearch={isMobile} />
                        )}
                    </Card>
                </MDBox>
            </MDBox>
        </DashboardLayout>
    );
};

Horoscope.propTypes = {
    tableData: PropTypes.array,
    cell: PropTypes.shape({
        row: PropTypes.shape({
            original: PropTypes.shape({
                fileType: PropTypes.string.isRequired,
                id: PropTypes.string.isRequired,
                createdOn: PropTypes.string.isRequired,
                name: PropTypes.string,
                description: PropTypes.string,
            }).isRequired,
        }).isRequired,
    }),
};

export default Horoscope;
